// Custom JS Application Code
function validate_email_js(email) { var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/; if(reg.test(email) == false) { return false; } return true; }
var ellipsisText = function (e, etc) { var wordArray = e.innerHTML.split(" "); while (e.scrollHeight > e.offsetHeight) { wordArray.pop(); e.innerHTML = wordArray.join(" ") + (etc || "..."); } };

function isInViewport(element) {
	const rect = element.getBoundingClientRect();
	return rect.top >= 0 &&
	rect.left >= 0 &&
	rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
	rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}

function checkHeaderOffset() {
	var $window = $(window);
	var offset = $window.scrollTop();
	if (offset>=30) {
		$('#headerWrapper').addClass('scrolled');
	}else{
		$('#headerWrapper').removeClass('scrolled');
	}
}

function checkLoadMorePosition() {
	const element = document.querySelector('.load-more-wrapper');
	if (element!=null) {
		const result = isInViewport(element);
		if (result) {
			if (js_vars.vars.loadMoreType=='post') {
				loadMorePosts();
			}
			if (js_vars.vars.loadMoreType=='filme') {
				loadMoreMovies();
			}
		}
	}
}

function windowOnResize() {
	var myWidth, myHeight;
	if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
	browserWidth = myWidth;
	browserHeight = myHeight;
}
function pageScroll() {
	checkHeaderOffset();
	checkLoadMorePosition();
}

function initNav(t) {
	var inTop = t.delta.y==0;
	var $window = $(window);
	if (inTop) {
		$('#headerWrapper').removeClass('scrolled');
		$('#headerWrapper').removeClass('scrolled-2');
		$('#headerWrapper').removeClass('scrolled-up');
	}else{
		if (t.direction=='up') {
			$('#headerWrapper').removeClass('scrolled');
			//$('#headerWrapper').addClass('scrolled-up scrolled-2');
		}else if (t.direction=='down') {
			$('#headerWrapper').addClass('scrolled');
			//$('#headerWrapper').removeClass('scrolled-up');
		}
	}
	return;
}

function decodeHtml(html) {
	var txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}
function loadMorePosts() {
	if (!inAjax) {
		var action = 'load_more_posts';
		setLoadMore();
		inAjax = true;
		$.ajax({ type: 'POST', url: js_vars.vars.ajaxurl, data: {
			//'wpml_lang' : js_vars.vars.my_current_lang,
			'offset_counter' : js_vars.vars.offsetCounter,
			'num_page_items' : js_vars.vars.pageItems,
			//'tag_id' : (tagID !== 0 ? tagID : ''),
			//'cat_id' : (catID !== 0 ? catID : ''),
			'search_query' : decodeHtml(js_vars.vars.searchQuery),
			'action': action
		}, success: function (result) {
			$('.news-page-wrapper .news-list').append(result.data.html);
			unsetLoadMore();
			inAjax = false;
			js_vars.vars.offsetCounter += result.data.total;
			if (js_vars.vars.totalPosts<=js_vars.vars.offsetCounter) {
				$('.js-load-more').parent().hide();
			}
			var children = document.querySelectorAll('.in-load-more');
			gsap.to(children, { opacity: 0, y: 50 });
			ScrollTrigger.batch(children, {
				onEnter: batch => {
					batch.forEach((item, index) => {
						gsap.to(item, {opacity: 1, y: 0, stagger: 0.25, delay: index * 0.3});
						$(item).removeClass('in-load-more');
					})
				},
				once: true,
				start: 'top 80%',
				//end: 'top 30%',
				//scroller: ".smooth-scroll",
			});
		}, error: function () {} });
	}
}

function loadMoreMovies() {
	if (!inAjax) {
		var action = 'load_more_movies';
		setLoadMore();
		inAjax = true;
		$.ajax({ type: 'POST', url: js_vars.vars.ajaxurl, data: {
			//'wpml_lang' : js_vars.vars.my_current_lang,
			'offset_counter' : js_vars.vars.offsetCounter,
			'num_page_items' : js_vars.vars.pageItems,
			//'tag_id' : (tagID !== 0 ? tagID : ''),
			//'cat_id' : (catID !== 0 ? catID : ''),
			'order_by' : decodeHtml(js_vars.vars.orderBy),
			'search_query' : decodeHtml(js_vars.vars.searchQuery),
			'action': action
		}, success: function (result) {
			$('.movies-page-wrapper .movies-list-wrapper').append(result.data.html);
			unsetLoadMore();
			inAjax = false;
			js_vars.vars.offsetCounter += result.data.total;
			if (js_vars.vars.totalPosts<=js_vars.vars.offsetCounter) {
				$('.js-load-more').parent().hide();
			}
			$('.js-view-trailer').bind('click',function(ev) {
				var videoId = $(this).data('video-id');
				$('.video-popup-wrapper .video-wrapper').html('<iframe src="https://player.vimeo.com/video/'+videoId+'?api=1" allow="autoplay" width="800" height="800" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
				$('.video-popup-wrapper').fadeIn();

				var iframe = $('.video-popup-wrapper .video-wrapper iframe').get(0);
				player = new Vimeo.Player(iframe);
				player.play();

				$(this).blur(); ev.preventDefault();
			});

			const rotateElements = gsap.utils.toArray('.in-load-more .js-rotate-anim');
			rotateElements.forEach(animItem => {
				gsap.to(animItem, {
					rotation: 360, duration: Math.random() * (5 - 3) + 3, ease: "none", repeat: -1
				});
			});

			var children = document.querySelectorAll('.in-load-more');
			gsap.to(children, { opacity: 0, y: 50 });
			ScrollTrigger.batch(children, {
				onEnter: batch => {
					batch.forEach((item, index) => {
						gsap.to(item, {opacity: 1, y: 0, stagger: 0.25, delay: index * 0.3});
						$(item).removeClass('in-load-more');
					})
				},
				once: true,
				start: 'top 80%',
				//end: 'top 30%',
				//scroller: ".smooth-scroll",
			});
		}, error: function () {} });
	}
}

function setLoadMore() {
	$('.js-load-more').addClass('is-loading');
	$('.js-load-more').text(js_vars.vars.loadingStr);
}
function unsetLoadMore() {
	$('.js-load-more').removeClass('is-loading');
	$('.js-load-more').text(js_vars.vars.loadMoreStr);
}

function checkEntryYoutubeVideos() {
	var iframes = document.getElementsByTagName('iframe');
	var key = /youtube.com/;
	for (var i = 0; i != iframes.length; ++i) {
		var match = iframes[i].src.search(key);
		if(match != -1) {
			$(iframes[i]).eq(0).addClass('video-player');
			$(iframes[i]).eq(0).closest('.with-iframe').addClass('video-wrapper');
		}
	}
}
function checkEntryVimeoVideos() {
	var iframes = document.getElementsByTagName('iframe');
	var key = /vimeo.com/;
	for (var i = 0; i != iframes.length; ++i) {
		var match = iframes[i].src.search(key);
		if(match != -1) {
			$(iframes[i]).eq(0).addClass('video-player');
			$(iframes[i]).eq(0).closest('.with-iframe').addClass('video-wrapper');
		}
	}
}

function scrollToSlide(slideTo) {
	$('body,html').animate({ scrollTop: $('.'+slideTo).offset().top-$('header').height() }, 800);
}

(function($) {
	"use strict"; // Start of use strict
	$(window).bind('hashchange');
	$(window).trigger('hashchange');
	$(window).scroll( function() { /*disableScroll();*/ pageScroll(); } );
	$(window).resize(function() { windowOnResize(); });
	$(window).ready(function() {
		var myWidth, myHeight;
		if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
		browserWidth = myWidth;
		browserHeight = myHeight;

		//if ($(window).width()>=1024) { new WOW().init(); }

		//$('.go-top a').click(function () { $('body,html').animate({ scrollTop: 0 }, 800); $(this).blur(); return false; });

		$('.entry-wysiwyg p iframe').closest('p').addClass('with-iframe');
		$('.entry-wysiwyg figure iframe').closest('figure').addClass('with-iframe');

		checkEntryYoutubeVideos();
		checkEntryVimeoVideos();

		$('.entry-wysiwyg p > img,.entry-wysiwyg p > video').closest('p').addClass('image-wrapper');
		$('.entry-wysiwyg p > img,.entry-wysiwyg p > video').addClass('responsive-full');

		$('.entry-wysiwyg figure > img:not(.alignleft,.alignright,.aligncenter),.entry-wysiwyg figure > a > img:not(.alignleft,.alignright,.aligncenter)').closest('figure').addClass('image-wrapper');
		$('.entry-wysiwyg figure > img:not(.alignleft,.alignright,.aligncenter),.entry-wysiwyg figure > a > img:not(.alignleft,.alignright,.aligncenter)').addClass('responsive-full');
		$('.entry-wysiwyg figure > video,.entry-wysiwyg figure > a > video').closest('figure').addClass('image-wrapper');
		$('.entry-wysiwyg figure > video,.entry-wysiwyg figure > a > video').addClass('responsive-full');

		$('.nav-toggle').bind('click',function(ev) {
			if ($('.header-container').hasClass('opened')) {
				$('body,html').css('overflow','');
				$('.header-container').fadeOut(0,function() {
					$(this).removeClass('opened');
					$('#headerWrapper').removeClass('opened');
				});
				$(this).removeClass('is-active');
			}else{
				$('#headerWrapper').addClass('opened');
				$('body,html').css('overflow','hidden');
				$('.header-container').fadeIn(0,function() {
					$(this).addClass('opened');
				});
				$(this).addClass('is-active');
			}
			$(this).blur();
			ev.preventDefault();
		});

		$('.js-view-trailer').bind('click',function(ev) {
			var videoId = $(this).data('video-id');
			$('.video-popup-wrapper .video-wrapper').html('<iframe src="https://player.vimeo.com/video/'+videoId+'?api=1" allow="autoplay" width="800" height="800" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
			$('.video-popup-wrapper').fadeIn();

			var iframe = $('.video-popup-wrapper .video-wrapper iframe').get(0);
			player = new Vimeo.Player(iframe);
			player.play();

			$(this).blur(); ev.preventDefault();
		});

		$('.js-close-video-popup').bind('click',function(ev) {
			player.pause();
			$('.video-popup-wrapper').fadeOut();
			$(this).blur(); ev.preventDefault();
		});

		$('.js-load-more').bind('click',function(ev) {
			if (js_vars.vars.loadMoreType=='post') {
				loadMorePosts();
			}
			if (js_vars.vars.loadMoreType=='filme') {
				loadMoreMovies();
			}
			$(this).blur(); ev.preventDefault();
		});

		$('.js-search-submit').bind('click',function(ev) {
			var inputVal = $('#searchform input#searchText').val().trim();
			var termLength = inputVal.length;
			if (termLength>=2) { $(this).closest('form').submit(); }
			$(this).blur(); ev.preventDefault();
		});
		$('form#searchform').submit(function(e){
			var inputVal = $('#searchform input#searchText').val().trim();
			var termLength = inputVal.length;
			if (termLength<2) { e.preventDefault(); }
		});

		$('.order-list-wrapper ul li a').bind('click',function(ev) {
			var orderBy = $(this).data('order');
			var currentUrl = location.protocol + '//' + location.host + location.pathname;
			if (js_vars.vars.searchQuery=='') {
				currentUrl += '?order_by=' + orderBy;
				location.href = currentUrl;
			}else{
				currentUrl += '?order_by=' + orderBy + '&s=' + js_vars.vars.searchQuery + '&post_type[]=filme';
				location.href = currentUrl;
			}

			$(this).blur(); ev.preventDefault();
		});

		$('.js-accept-cookies').bind('click',function(ev) {
			$('.cookies-popup-wrapper').fadeOut();
			Cookies.set('cookies_accepted', '1', { expires: 90 });
			$(this).blur(); ev.preventDefault();
		});
		if (Cookies.get('cookies_accepted')==undefined) { $('.cookies-popup-wrapper').show(); }


	});
	$(window).on('load',function() {
		var myWidth, myHeight;
		if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
		browserWidth = myWidth;
		browserHeight = myHeight;

		if ($('.media-gallery').length) {
			$('.media-gallery').each(function() {
				var currentId = $(this).attr('id');
				new Swiper('#'+currentId+' .swiper-container', {
					slidesPerView: 'auto',
					centeredSlides : false,
					spaceBetween: 20,
					loop: false,
					autoHeight: false,
					freeMode: { enabled: true, },
					navigation: {
						nextEl: '#'+currentId+' .swiper-navigation .swiper-custom-next',
						prevEl: '#'+currentId+' .swiper-navigation .swiper-custom-prev',
					}
				});
			});
		}

		if ($('.hp-intro-slider').length) {
			$('.hp-intro-slider').each(function() {
				var currentId = $(this).attr('id');
				new Swiper('#'+currentId+' .swiper-container', {
					//slidesPerView: 'auto',
					//centeredSlides : false,
					//spaceBetween: 20,
					loop: true,
					speed: 1000,
					/*
					modules: [SwiperGL],
					effect: 'gl',
					gl: {
						shader: 'morph-x',
					},
					*/
					//autoHeight: false,
					//freeMode: { enabled: true, },
					pagination: {
						el: '#'+currentId+' .swiper-custom-pagination',
						type: 'custom',
						renderCustom: function(swiper,current,total) {
							return '<span class="current">' + current + '</span><span>/</span><span>' + total + '</span>';
						}
					},
					navigation: {
						nextEl: '#'+currentId+' .swiper-custom-button-next',
						prevEl: '#'+currentId+' .swiper-custom-button-prev',
					},
				});
			});
		}
	});

})(jQuery); // End of use strict

var locoScroll;
window.addEventListener('DOMContentLoaded', (event) => {
	gsap.registerPlugin(ScrollTrigger,SplitText,ScrollSmoother);

	smoother = ScrollSmoother.create({
		normalizeScroll: true,
		smooth: 3,
		effects: true,
		//onUpdate: self => console.log("direction:", self.direction)
	});
});
window.addEventListener('DOMContentLoaded', (event) => {
	(function($) {
		"use strict"; // Start of use strict
		$(window).on('load',function() {
			ScrollTrigger.matchMedia({
				"(max-width: 767px)": function() {},
				"(min-width: 800px)": function() {},
				"(min-width: 834px)": function() {},
				"(min-width: 1024px)": function() {},
				"all": function() {
					var newScrollDirection = 'down';
					const body = document.querySelector('body');
					const headerWrapper = document.getElementById('headerWrapper');
					ScrollTrigger.create({
						//markers: true,
						trigger: body,
						start: 'top 20%',
						onUpdate: self => {
						  if (self.direction === 1) {
							newScrollDirection = 'down';
							headerWrapper.classList.add('scrolled-down');
							headerWrapper.classList.remove('scrolled-up');
						  } else {
							newScrollDirection = 'up';
							headerWrapper.classList.add('scrolled-up');
							headerWrapper.classList.remove('scrolled-down');
						  }
						  if (lastScrollDirection!=newScrollDirection) {
							lastScrollDirection = newScrollDirection;
						  }
						},
						onLeaveBack: () => {
						  headerWrapper.classList.remove('scrolled-up');
						},
					});

					const rotateElements = gsap.utils.toArray('.js-rotate-anim');
					rotateElements.forEach(animItem => {
						gsap.to(animItem, {
							rotation: 360, duration: Math.random() * (5 - 3) + 3, ease: "none", repeat: -1
						});
					});

					var appearListItems = gsap.utils.toArray('[data-appear-list]');
					appearListItems.forEach(animList => {
						var children = animList.querySelectorAll('.'+animList.getAttribute('data-appear-child'));
						gsap.to(children, { opacity: 0, y: 50 });
						ScrollTrigger.batch(children, {
							onEnter: batch => {
								batch.forEach((item, index) => gsap.to(item, {opacity: 1, y: 0, stagger: 0.25, delay: index * 0.3}))
							},
							once: true,
							start: 'top 80%',
							//end: 'top 30%',
							//scroller: ".smooth-scroll",
						});
					});
				},
			});

		});
	})(jQuery); // End of use strict
});

var browserWidth = 0;
var browserHeight = 0;
var smoother;
var inAjax = false;
var player = false;
var lastScrollDirection = 'down';
